export default function GenerateSearchString({ size }) {
  return (
    <svg
      width="52"
      height="52"
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_6594_198322)">
        <path
          d="M12 1.5H40C45.2467 1.5 49.5 5.75329 49.5 11V39C49.5 44.2467 45.2467 48.5 40 48.5H12C6.7533 48.5 2.5 44.2467 2.5 39V11C2.5 5.7533 6.75329 1.5 12 1.5Z"
          stroke="#EAECF0"
          shape-rendering="crispEdges"
        />
        <g clip-path="url(#clip0_6594_198322)">
          <path
            d="M31.25 30.25C30.2117 30.25 29.1966 29.9421 28.3333 29.3652C27.4699 28.7883 26.797 27.9684 26.3996 27.0091C26.0023 26.0498 25.8983 24.9942 26.1009 23.9758C26.3035 22.9574 26.8035 22.0219 27.5377 21.2877C28.2719 20.5535 29.2074 20.0535 30.2258 19.8509C31.2442 19.6483 32.2998 19.7523 33.2591 20.1496C34.2184 20.547 35.0383 21.2199 35.6152 22.0833C36.1921 22.9466 36.5 23.9617 36.5 25C36.4985 26.3919 35.9448 27.7264 34.9606 28.7106C33.9764 29.6948 32.6419 30.2485 31.25 30.25ZM31.25 21.25C30.5083 21.25 29.7833 21.4699 29.1666 21.882C28.5499 22.294 28.0693 22.8797 27.7855 23.5649C27.5016 24.2502 27.4274 25.0042 27.5721 25.7316C27.7168 26.459 28.0739 27.1272 28.5984 27.6517C29.1228 28.1761 29.791 28.5333 30.5184 28.6779C31.2458 28.8226 31.9998 28.7484 32.6851 28.4646C33.3703 28.1807 33.956 27.7001 34.368 27.0834C34.7801 26.4667 35 25.7417 35 25C34.9989 24.0058 34.6035 23.0526 33.9004 22.3496C33.1974 21.6465 32.2442 21.2511 31.25 21.25Z"
            fill="#070017"
          />
          <path
            d="M20.75 30.25C23.6495 30.25 26 27.8995 26 25C26 22.1005 23.6495 19.75 20.75 19.75C17.8505 19.75 15.5 22.1005 15.5 25C15.5 27.8995 17.8505 30.25 20.75 30.25Z"
            fill="#070017"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_6594_198322"
          x="0"
          y="0"
          width="52"
          height="52"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6594_198322"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6594_198322"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_6594_198322">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(14 13)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
